import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {makeObservable, observable, computed} from "mobx";
import {STANDINGS_WIDGET} from "../standings-widget.consts";

export class StandingsWidgetCellViewModel extends BaseViewModel {
  @observable value: String;
  @observable key: String;
  @observable isMajor: Boolean;
  @observable isBold: Boolean;
  @observable isRecentForm: Boolean;
  @observable isLive: Boolean;

  constructor(value, key: String, isMajor: Boolean, isBold: Boolean, isRecentForm: Boolean, isLive: Boolean) {
    super();

    this.value = value === undefined ? '-' : value;
    this.key = key;
    this.isMajor = isMajor;
    this.isBold = isBold;
    this.isRecentForm = isRecentForm;
    this.isLive = isLive;

    makeObservable(this);
  }

  @computed get isNextMatch(): Boolean {
    return this.key === STANDINGS_WIDGET.NEXT_MATCH_KEY;
  }
}
